<script>

import { defineComponent } from 'vue'
import PieChart from '@/components/charts/PieChart.vue'
import PageLayout from '@/layouts/PageLayout.vue'
import PageHeaderLayout from '@/layouts/PageHeaderLayout.vue'

export default defineComponent({
  name: 'UserMonitor',
  components: { PageHeaderLayout, PageLayout, PieChart }
})
</script>

<template>
  <div>
    <PageHeaderLayout>
      <div class='main-page-content'>
        <h3>数据监控：用户</h3>
        <div>
          <PieChart></PieChart>
        </div>
      </div>
    </PageHeaderLayout>

  </div>
</template>

<style scoped>

</style>
